export const SAMPLE_ORDERS = [
  {
    orderId: "ORD-2026-001",
    customerName: "Rahul Sharma",
    customerEmail: "rahul.sharma@email.com",
    customerPhone: "+91-9876543210",
    status: "delivered",
    totalAmount: 35999,
    paymentMethod: "UPI",
    shippingAddress: "42, MG Road, Sector 14, Gurugram, Haryana - 122001",
    createdAt: "2026-01-15T10:30:00.000Z",
    updatedAt: "2026-01-20T14:00:00.000Z",
    items: [
      { productId: "prod-hp-elitebook-840-g7", name: "HP EliteBook 840 G7", qty: 1, price: 35999 },
    ],
    tracking: {
      courier: "Delhivery",
      trackingId: "DL2026012345678",
      timeline: [
        { status: "Order Placed", date: "2026-01-15T10:30:00.000Z", description: "Your order has been placed successfully" },
        { status: "Confirmed", date: "2026-01-15T12:00:00.000Z", description: "Payment confirmed, order processing" },
        { status: "Processing", date: "2026-01-16T09:00:00.000Z", description: "Quality check and packaging in progress" },
        { status: "Shipped", date: "2026-01-17T11:30:00.000Z", description: "Picked up by Delhivery courier" },
        { status: "In Transit", date: "2026-01-18T08:00:00.000Z", description: "Package arrived at Gurugram hub" },
        { status: "Out for Delivery", date: "2026-01-20T07:00:00.000Z", description: "Out for delivery to your address" },
        { status: "Delivered", date: "2026-01-20T14:00:00.000Z", description: "Successfully delivered. Signed by: R. Sharma" },
      ],
    },
  },
  {
    orderId: "ORD-2026-002",
    customerName: "Priya Patel",
    customerEmail: "priya.patel@email.com",
    customerPhone: "+91-8765432109",
    status: "shipped",
    totalAmount: 58999,
    paymentMethod: "Credit Card",
    shippingAddress: "15, Park Avenue, Andheri West, Mumbai, Maharashtra - 400058",
    createdAt: "2026-02-01T09:15:00.000Z",
    updatedAt: "2026-02-05T16:30:00.000Z",
    items: [
      { productId: "prod-apple-macbook-air-m1", name: "Apple MacBook Air M1", qty: 1, price: 58999 },
    ],
    tracking: {
      courier: "BlueDart",
      trackingId: "BD2026098765432",
      timeline: [
        { status: "Order Placed", date: "2026-02-01T09:15:00.000Z", description: "Order placed via website" },
        { status: "Confirmed", date: "2026-02-01T10:00:00.000Z", description: "Payment of ₹58,999 confirmed" },
        { status: "Processing", date: "2026-02-02T08:00:00.000Z", description: "Quality inspection started" },
        { status: "Shipped", date: "2026-02-03T14:00:00.000Z", description: "Dispatched from Jaipur warehouse" },
        { status: "In Transit", date: "2026-02-05T16:30:00.000Z", description: "Arrived at Mumbai sorting facility" },
      ],
    },
  },
  {
    orderId: "ORD-2026-003",
    customerName: "Amit Kumar",
    customerEmail: "amit.kumar@email.com",
    customerPhone: "+91-7654321098",
    status: "processing",
    totalAmount: 68999,
    paymentMethod: "Net Banking",
    shippingAddress: "23, Koramangala, 4th Block, Bangalore, Karnataka - 560034",
    createdAt: "2026-02-07T14:45:00.000Z",
    updatedAt: "2026-02-08T09:00:00.000Z",
    items: [
      { productId: "prod-lenovo-legion-5", name: "Lenovo Legion 5", qty: 1, price: 68999 },
    ],
    tracking: {
      courier: "DTDC",
      trackingId: "DT2026567890123",
      timeline: [
        { status: "Order Placed", date: "2026-02-07T14:45:00.000Z", description: "Order confirmed" },
        { status: "Confirmed", date: "2026-02-07T16:00:00.000Z", description: "Payment verification complete" },
        { status: "Processing", date: "2026-02-08T09:00:00.000Z", description: "Preparing your laptop for shipment" },
      ],
    },
  },
  {
    orderId: "ORD-2026-004",
    customerName: "Sneha Reddy",
    customerEmail: "sneha.r@email.com",
    customerPhone: "+91-6543210987",
    status: "pending",
    totalAmount: 32999,
    paymentMethod: "COD",
    shippingAddress: "78, Jubilee Hills, Road No. 36, Hyderabad, Telangana - 500033",
    createdAt: "2026-02-09T16:20:00.000Z",
    updatedAt: "2026-02-09T16:20:00.000Z",
    items: [
      { productId: "prod-lenovo-thinkpad-e14", name: "Lenovo ThinkPad E14", qty: 1, price: 32999 },
    ],
    tracking: {
      courier: "Pending Assignment",
      trackingId: "",
      timeline: [
        { status: "Order Placed", date: "2026-02-09T16:20:00.000Z", description: "COD order placed, awaiting confirmation" },
      ],
    },
  },
  {
    orderId: "ORD-2026-005",
    customerName: "Vikram Singh",
    customerEmail: "vikram.s@email.com",
    customerPhone: "+91-5432109876",
    status: "cancelled",
    totalAmount: 94999,
    paymentMethod: "EMI",
    shippingAddress: "99, Civil Lines, Jaipur, Rajasthan - 302006",
    createdAt: "2026-01-25T11:00:00.000Z",
    updatedAt: "2026-01-26T08:30:00.000Z",
    items: [
      { productId: "prod-apple-macbook-pro-m2", name: "Apple MacBook Pro M2", qty: 1, price: 94999 },
    ],
    tracking: {
      courier: "N/A",
      trackingId: "",
      timeline: [
        { status: "Order Placed", date: "2026-01-25T11:00:00.000Z", description: "EMI order placed" },
        { status: "Cancelled", date: "2026-01-26T08:30:00.000Z", description: "Cancelled by customer. Refund initiated." },
      ],
    },
  },
  {
    orderId: "ORD-2026-006",
    customerName: "Neha Gupta",
    customerEmail: "neha.g@email.com",
    customerPhone: "+91-4321098765",
    status: "delivered",
    totalAmount: 28999,
    paymentMethod: "Debit Card",
    shippingAddress: "55, Gomti Nagar, Lucknow, Uttar Pradesh - 226010",
    createdAt: "2026-01-10T08:30:00.000Z",
    updatedAt: "2026-01-14T15:30:00.000Z",
    items: [
      { productId: "prod-dell-lat-5410", name: "Dell Latitude 5410", qty: 1, price: 28999 },
    ],
    tracking: {
      courier: "FedEx",
      trackingId: "FX2026112233445",
      timeline: [
        { status: "Order Placed", date: "2026-01-10T08:30:00.000Z", description: "Order placed" },
        { status: "Confirmed", date: "2026-01-10T10:00:00.000Z", description: "Payment confirmed" },
        { status: "Processing", date: "2026-01-11T07:00:00.000Z", description: "Laptop tested and packed" },
        { status: "Shipped", date: "2026-01-11T17:00:00.000Z", description: "Handed to FedEx" },
        { status: "In Transit", date: "2026-01-13T09:00:00.000Z", description: "In transit via Lucknow hub" },
        { status: "Out for Delivery", date: "2026-01-14T08:00:00.000Z", description: "Out for delivery" },
        { status: "Delivered", date: "2026-01-14T15:30:00.000Z", description: "Delivered successfully" },
      ],
    },
  },
  {
    orderId: "ORD-2026-007",
    customerName: "Karan Mehta",
    customerEmail: "karan.m@email.com",
    customerPhone: "+91-3210987654",
    status: "shipped",
    totalAmount: 75999,
    paymentMethod: "UPI",
    shippingAddress: "12, Shivaji Nagar, Pune, Maharashtra - 411005",
    createdAt: "2026-02-05T13:00:00.000Z",
    updatedAt: "2026-02-08T10:00:00.000Z",
    items: [
      { productId: "prod-dell-xps-13", name: "Dell XPS 13", qty: 1, price: 75999 },
    ],
    tracking: {
      courier: "Delhivery",
      trackingId: "DL2026778899001",
      timeline: [
        { status: "Order Placed", date: "2026-02-05T13:00:00.000Z", description: "Order received" },
        { status: "Confirmed", date: "2026-02-05T15:00:00.000Z", description: "UPI payment confirmed" },
        { status: "Processing", date: "2026-02-06T08:00:00.000Z", description: "Processing at warehouse" },
        { status: "Shipped", date: "2026-02-07T12:00:00.000Z", description: "Shipped from Jaipur" },
        { status: "In Transit", date: "2026-02-08T10:00:00.000Z", description: "At Pune distribution center" },
      ],
    },
  },
  {
    orderId: "ORD-2026-008",
    customerName: "Divya Nair",
    customerEmail: "divya.n@email.com",
    customerPhone: "+91-2109876543",
    status: "confirmed",
    totalAmount: 64999,
    paymentMethod: "Credit Card",
    shippingAddress: "31, MG Road, Kochi, Kerala - 682016",
    createdAt: "2026-02-10T07:00:00.000Z",
    updatedAt: "2026-02-10T08:30:00.000Z",
    items: [
      { productId: "prod-asus-rog-strix-g15", name: "ASUS ROG Strix G15", qty: 1, price: 64999 },
    ],
    tracking: {
      courier: "BlueDart",
      trackingId: "BD2026445566778",
      timeline: [
        { status: "Order Placed", date: "2026-02-10T07:00:00.000Z", description: "New order received" },
        { status: "Confirmed", date: "2026-02-10T08:30:00.000Z", description: "Payment verified, processing soon" },
      ],
    },
  },
];

